import { Input, OnChanges, SimpleChanges, Output, EventEmitter, QueryList, ViewChildren, ElementRef, IterableDiffers, ViewChild, Renderer2, AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControlName } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { CodeList, MinutesCollabDetails, MeetingCollabDetails, MeetingResponse } from 'src/app/models/basicMeetingModel';
import { Globals } from 'src/app/service/global';
import { PreviousMeetingHistoryDialogComponent } from '../previous-meeting-history-dialog/previous-meeting-history-dialog.component';
import { DatePipe } from '@angular/common'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MeetingService } from 'src/app/service/meeting.service';
import { FocusOnErrorDirective } from 'src/app/directives/focus-on-error.directives'
// import * as $ from 'jquery';
import $ from 'jquery';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { ConfidentialDialogComponent } from '../../components/confidential-dialog/confidential-dialog.component';

//autocomplete form
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { PreviousMeetingsComponent } from '../previous-meetings/previous-meetings.component';
import { Breakpoints, BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MatRadioChange } from '@angular/material/radio';
import { environment, environment_const, environment_msg } from 'src/environments/environment';
import { Utils } from 'ngx-bootstrap/utils';
import { UtilityService } from 'src/app/service/utility.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues } from 'src/environments/environment';
import { PermissionService } from 'src/app/service/permission.service';
import { UserService } from 'src/app/service/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { TemplateDialogComponent } from '../template-dialog/template-dialog.component';
import { LoginService } from 'src/app/service/login.service';


export interface ProductName {
  name: string;
}

// const moment = _rollupMoment || _moment;
const moment = require('moment');

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'dddd, MMMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-instant-meeting-description',
  templateUrl: './instant-meeting-description.component.html',
  styleUrls: ['./instant-meeting-description.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]

})
export class InstantMeetingDescriptionComponent implements OnInit, OnChanges, AfterViewInit {
  //instant Meeting Started variable
  @Output() meetingMediumChanged: EventEmitter<any> = new EventEmitter<any>();

  @Input() instantMeetingStarted: any;
  @Input() meetingStarted: any
  @Input() meetingEnded: any
  @Input() showStart: any
  @Input('swap') swap: any;
  minDate = new Date();
  @ViewChildren(FocusOnErrorDirective)
  focusFields!: QueryList<FocusOnErrorDirective>;
  fieldOpener = false;
  meetingTimeZone: any;
  selectedCategory = new UntypedFormControl();
  selectedSubCategory = new UntypedFormControl();
  subCategories: any[] = [];
  categoryType: any = <any>[];

  selectedTemplateName: any;
  location = new UntypedFormControl();
  meetingDate = new UntypedFormControl();
  meetingFrequency = new UntypedFormControl();
  meetingType = new UntypedFormControl();
  meetingMedium = new UntypedFormControl();
  isConfidential = new UntypedFormControl();
  defaultApproval = new UntypedFormControl();
  recurTillDateStr = new UntypedFormControl();
  meetingPurpose = new UntypedFormControl();
  recurChange = new UntypedFormControl();
  zoomCheck = new UntypedFormControl();
  weekEndFlag = new UntypedFormControl();
  durationMaxChar = 3;
  options: any
  today: any
  confidentialCheck = false;
  meetingTypeField: any = <any>[];
  meetingMediumField: any = <any>[];
  currentDate: any
  editing: boolean = false;
  date = new UntypedFormControl(moment());
  selectedFrequency: any = "N"
  meetingTitle: any;
  meetingTitleChange: any;
  meetingTitleEvent: any;
  events: string[] = [];
  differ: any;
  meetingStartTime: any;
  meetingDateSet: any;
  minTillDate: any = new Date();
  templateForm = new UntypedFormGroup({
    templateName: new UntypedFormControl('', Validators.required),
    categoryStates: new UntypedFormControl('', Validators.required),
    templateDesc: new UntypedFormControl(''),
    categoryName: new UntypedFormControl('', Validators.required),
    participants: new UntypedFormControl([true]),
    notes: new UntypedFormControl([true])
  })

  //product / project title
  productTitle = new UntypedFormControl();
  isZoomMeeting: any = false;
  productOptions: ProductName[] = [{ name: 'Agora' }, { name: 'Jikan' }, { name: 'AFM' }, { name: 'Ncoup' }, { name: 'IDS' }, { name: 'Pheme' }];
  // filteredOptions!: Observable<ProductName[]>;
  filteredOptions: Observable<any[]> = of([]);
  projectList: any[] = [];
  selectedFrequencyPopup: boolean = false;
  repeatDayInMonthValue: any;
  @ViewChild('scrollTarget') scrollTarget?: ElementRef;
  frequencyType = [
    { name: "Once", value: 'N' },
    { name: "Daily", value: 'D' },
    { name: "Weekly", value: 'W' },
    { name: "Monthly", value: 'M' },
    { name: "Yearly", value: 'Y' }
  ];

  meetingRepeatDays: any = [
    { name: '1 Day', value: 1 },
    { name: '2 Days', value: 2 },
    { name: '3 Days', value: 3 },
    { name: '4 Days', value: 4 }
  ];

  meetingRepeatWeeks: any = [
    { name: '1 Week', value: 1 },
    { name: '2 Weeks', value: 2 },
    { name: '3 Weeks', value: 3 },
    { name: '4 Weeks', value: 4 }
  ]

  meetingRepeatMonths: any = [
    { name: '1 Month', value: 1 },
    { name: '2 Months', value: 2 },
    { name: '3 Months', value: 3 },
    { name: '4 Months', value: 4 }
  ]

  meetingRepeatYears: any = [
    { name: '1 Year', value: 1 },
    { name: '2 Years', value: 2 },
    { name: '3 Years', value: 3 },
    { name: '4 Years', value: 4 }
  ]

  meetingDayInMonth: any = [
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
    { name: '5', value: 5 },
    { name: '6', value: 6 },
    { name: '7', value: 7 },
    { name: '8', value: 8 },
    { name: '9', value: 9 },
    { name: '10', value: 10 },
    { name: '11', value: 11 },
    { name: '12', value: 12 },
    { name: '13', value: 13 },
    { name: '14', value: 14 },
    { name: '15', value: 15 },
    { name: '16', value: 16 },
    { name: '17', value: 17 },
    { name: '18', value: 18 },
    { name: '19', value: 19 },
    { name: '20', value: 20 },
    { name: '21', value: 21 },
    { name: '22', value: 22 },
    { name: '23', value: 23 },
    { name: '24', value: 24 },
    { name: '25', value: 25 },
    { name: '26', value: 26 },
    { name: '27', value: 27 },
    { name: '28', value: 28 },
    { name: '29', value: 29 },
    { name: '30', value: 30 },
    { name: '31', value: 31 },
  ]

  meetingWeekInMonth = [
    { name: '1st Week', value: 1 },
    { name: '2nd Week', value: 2 },
    { name: '3rd Week', value: 3 },
    { name: '4th Week', value: 4 },
    { name: '5th week', value: 5 }
  ]

  meetingMonths = [
    { name: 'Jan', value: 1 },
    { name: 'Feb', value: 2 },
    { name: 'Mar', value: 3 },
    { name: 'Apr', value: 4 },
    { name: 'May', value: 5 },
    { name: 'Jun', value: 6 },
    { name: 'Jul', value: 7 },
    { name: 'Aug', value: 8 },
    { name: 'Sep', value: 9 },
    { name: 'Oct', value: 10 },
    { name: 'Nov', value: 11 },
    { name: 'Dec', value: 12 }
  ]

  meetingDayInWeek = [
    { name: 'Mon', value: 1, checked: false },
    { name: 'Tue', value: 2, checked: false },
    { name: 'Wed', value: 3, checked: false },
    { name: 'Thu', value: 4, checked: false },
    { name: 'Fri', value: 5, checked: false },
    { name: 'Sat', value: 6, checked: false },
    { name: 'Sun', value: 0, checked: false },
  ]

  meetingDaysCheckbox: any = [
    { name: 'Sun', value: 0, checked: false },
    { name: 'Mon', value: 1, checked: false },
    { name: 'Tue', value: 2, checked: false },
    { name: 'Wed', value: 3, checked: false },
    { name: 'Thu', value: 4, checked: false },
    { name: 'Fri', value: 5, checked: false },
    { name: 'Sat', value: 6, checked: false },
  ]

  day: boolean = true;
  weekDay: boolean = false;
  monthDay: boolean = true;
  monthweekDay: boolean = false;

  //accordion expansion varaible
  expansion = false
  // @Output() pinDialogTriggered = new EventEmitter<boolean>();
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Output() booleanEmit: any = new EventEmitter<any>();
  @Output() meetingStatusEmit = new EventEmitter();
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  pastMeetingTourValues = pastMeetingTourValues
  disbaleMeetingElem: any;
  frequencyValue: string = '';
  repeatValue: Number = 1;
  tillDate: any;
  repeatWeekInMonthValue: any;
  repeatYearlyInMonthValue: any;
  repeatYearlyWeekValue: any;
  repeatYearlyWeekDayValue: any;
  repeatMonthYearValue: any;
  repeatDayInYearValue: any;
  repeatWeekDayInMonthValue: any;
  categoryId: any;
  pickeropen:any;

  constructor(private permissionService: PermissionService, public notifiy: NotifierService, public sideNav: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, private commonService: FreeFormAgendaService, private differs: IterableDiffers, private webTranService: WebsocketTransferService, private el: ElementRef, private dialog: MatDialog, public datepipe: DatePipe, private meetingService: MeetingService, private globals: Globals, private utilService: UtilityService, private userService: UserService, private spinner: NgxSpinnerService, private loginService: LoginService) {
    this.differ = differs.find([]).create(undefined);
    this.loginService.getProjectList().subscribe((responsedata: any) => {

      if (responsedata.body && responsedata.body.length !== 0) {
        this.projectList = responsedata.body;
      } else {
        const flatList = [].concat.apply([], this.globals.globalProjectList);

        // Convert globalProjectList structure to match codeId/description format
        this.projectList = flatList.map((item: any) => ({
          codeId: item.id,
          description: item.label
        }));
      }
      this.filteredOptions = this.productTitle.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );
    });
    var categoryReq = {
      "orgCode": localStorage.getItem("orgCode"),
      "userId": localStorage.getItem("userId")
    };
    this.meetingService.loadCategory(categoryReq).subscribe((response: any) => {
      this.categoryType = response.body;
    });
    this.commonService.meetTime$.subscribe(resp => {
      this.updateMeetingInfo.controls['duration'].setValue(resp);
    });
  }
  ngAfterViewInit() {
  }

  ngAfterViewChecked() {


  }
  ngOnChanges() {

    this.meetingService.currentMessage.subscribe((data: any) => {

      this.updateMeetingInfo.controls['duration'].setValue(data);
    });

    this.meetingTypeField = this.meetingTypeResponse
    this.meetingMediumField = this.meetingMediumResponse
    this.meetingTimeZone = this.globals.vShortTimeZone;

    if (this.meetingResponse.meetingUTCDate != undefined) {
      const curSysDate = new Date(this.meetingResponse.meetingUTCDate);
      const tempDate = new Date(curSysDate.getTime());
      const _utcDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds());

      const meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
      const fullDate = new Date(_utcDate.getTime() + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
      const hour = this.addZero(fullDate.getHours());
      const minutes = this.addZero(fullDate.getMinutes());

      this.meetingStartTime = hour + ":" + minutes;
      this.meetingDateSet = fullDate;
      this.minTillDate = fullDate;

      this.setData();
      // if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
      //   this.sideNav.disablePageAfterApproval();
      // }
    }

  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  @Output() valueChange = new EventEmitter;
  @Input() meetingResponse !: MeetingResponse;
  @Input() meetingTypeResponse!: CodeList;
  @Input() meetingMediumResponse!: CodeList;

  //Date content emit function UI change
  @Output() dateContentEmit = new EventEmitter<any>();

  //Minutes content emit function UI change
  @Output() minuteContentEmit = new EventEmitter<any>();

  //Seconds content emit function UI change
  @Output() secondContentEmit = new EventEmitter<any>();

  //accordion expansion output variable
  @Output() sectionOpener = new EventEmitter;

  //pin dialog output variable
  @Output() openPinDialog = new EventEmitter();

  @Output() createZoomMeeting = new EventEmitter<any>();

  @Input() useBool: any;
  @Output() latestMeetingResponse: any = new EventEmitter();
  @Input() meetingduration: any;
  openFields() {
    this.fieldOpener = !this.fieldOpener
  }

  //duration hardcoded variable
  durationValue = "60"
  unCheckConfidential = false
  xl = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  lg = {
    panelClass: ['animate__animated', 'animate__slideInRight', 'animate__faster'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  md = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "30%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  sm = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 100px)",
    height: "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 0px)",
    height: "calc(100% - 0px)",
  }
  //form control
  @Input() updateMeetingInfo = new UntypedFormGroup({
    // meetingTitle: new FormControl('', [Validators.required]),
    duration: new UntypedFormControl('', [Validators.required, Validators.maxLength(3)]),
    meetingStartTime: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
    meetingDateStr: new UntypedFormControl('', [Validators.required]),
    orgCode: new UntypedFormControl('', [Validators.required]),
    userId: new UntypedFormControl('', [Validators.required]),
    visitorTimeZone: new UntypedFormControl('', [Validators.required]),
  });

  public checkError = (controlName: string, errorName: string) => {
    return this.updateMeetingInfo.controls[controlName].hasError(errorName);
  }

  //used to set values in formControl
  setData() {
    // this.updateMeetingInfo.controls['meetingTitle'].setValue(this.meetingResponse.meetingTitle)
    this.updateMeetingInfo.controls['meetingDateStr'].setValue(this.meetingResponse.meetingDateShortFormat)
    this.updateMeetingInfo.controls['meetingStartTime'].setValue(this.meetingStartTime)
    this.updateMeetingInfo.controls['duration'].setValue(this.meetingResponse.duration)
    this.updateMeetingInfo.controls['orgCode'].setValue(this.globals.orgCode)
    this.updateMeetingInfo.controls['userId'].setValue(this.globals.userId)
    this.updateMeetingInfo.controls['visitorTimeZone'].setValue(this.globals.vTimeZone)

    if (this.meetingResponse.categoryId != null) {
      const req = {
        fkCategory: this.meetingResponse.categoryId,
        "orgCode": localStorage.getItem("orgCode"),
        "createdBy": localStorage.getItem("userId")
      };

      this.meetingService.fetchMinutesTemplate(req).subscribe((response: any) => {
        this.subCategories = response.body;
        const selectedTemplateName = this.meetingResponse.minTemplateId;
        this.selectedSubCategory.setValue(selectedTemplateName);
      });
    }

    if (this.meetingResponse.zoomCreateMeeting == null) {
      this.zoomCheck.setValue("Y");
    } else {
      this.zoomCheck.setValue(this.meetingResponse.zoomCreateMeeting);
    }
    this.location.setValue(this.meetingResponse.location);
    this.meetingPurpose.setValue(this.meetingResponse.meetingPurpose);
    this.meetingDate.setValue(this.meetingDateSet);
    this.minTillDate = this.meetingDateSet;
    const selectedMeetingType = this.meetingResponse.meetingType;
    this.meetingType.setValue(selectedMeetingType);
    const selectedProjectType = this.meetingResponse.projectType;
    this.productTitle.setValue(selectedProjectType);
    const selectedMeetingMedium = this.meetingResponse.meetingMedium;
    this.meetingMedium.setValue(selectedMeetingMedium);
    const selectedCategoryName = this.meetingResponse.categoryId;
    this.selectedCategory.setValue(selectedCategoryName);
    if (this.categoryType && this.categoryType.length > 0) {
      if (this.meetingResponse.categoryId === null) {
        var codeDto = { parentCode: 'TCATEGORY', code: 'general' }
        this.meetingService.getTZNameByCode(codeDto).subscribe(responsedata => {
          this.selectedCategory.setValue(responsedata.body.codeId);
          const req = {
            fkCategory: responsedata.body.codeId,
            "orgCode": localStorage.getItem("orgCode"),
            "createdBy": localStorage.getItem("createdBy")
          };
          this.meetingService.fetchMinutesTemplate(req).subscribe((response: any) => {
            this.subCategories = response.body;
            this.selectedSubCategory.setValue(1);
          });
        })
      }
    }

    if (this.meetingResponse.meetingMediumDesc == "Zoom") {
      this.isZoomMeeting = true;
    }
    if (this.meetingResponse.isConfidential == "Y") {
      this.unCheckConfidential = true
    }
    else {
      this.unCheckConfidential = false;
    }
    this.defaultApproval.setValue(this.utilService.nvl(this.meetingResponse.approvalHours) == "" ? "0" : this.meetingResponse.approvalHours);
    this.weekEndFlag.setValue(this.meetingResponse!.weekEndFlag == 'Y' ? true : false);
    this.selectedFrequency = this.meetingResponse!.meetingFrequency == null || undefined ? "N" : this.meetingResponse.meetingFrequency;
    this.meetingFrequency.setValue(this.selectedFrequency);

    if (this.meetingResponse.recurTillDateStr != null)
      this.recurTillDateStr.setValue(new Date(this.meetingResponse.recurTillDateStr));

    if (this.meetingResponse.frequentVal != 0) {
      this.repeatValue = this.meetingResponse.frequentVal;
    }
    this.selectedFrequencyPopup = false;
    var a = this.recurTillDateStr.value == null || undefined ? " starting " + this.datepipe.transform(this.meetingDate.value, 'EEEE, MMMM d, y') : " untill " + this.datepipe.transform(this.recurTillDateStr.value, 'EEEE, MMMM d, y');
    if (this.meetingFrequency.value == 'D') {
      if (this.repeatValue == 1) {
        this.frequencyValue = 'Occurs every day ' + a + " " + this.meetingResponse.shortTimeZone;
      } else {
        this.frequencyValue = 'Occurs every  ' + this.repeatValue + 'days ' + a + " " + this.meetingResponse.shortTimeZone;
      }
    }
    if (this.meetingFrequency.value == 'W') {
      this.meetingResponse.onDate.forEach((data: any) => {
        this.meetingDaysCheckbox[data].checked = true;
      })

      const checkedValues = this.meetingDaysCheckbox
        .filter((item: any) => item.checked)
        .map((item: any) => item.name);

      if (this.repeatValue == 1) {
        this.frequencyValue = 'Occurs every weeks on' + checkedValues + a + " " + this.meetingResponse.shortTimeZone;
      } else {
        this.frequencyValue = 'Occurs every  ' + this.repeatValue + ' weeks on ' + checkedValues + a + " " + this.meetingResponse.shortTimeZone;
      }
    }

    if (this.meetingFrequency.value == 'M') {

      if (this.meetingResponse.onDate.length == 1) {
        this.day = true;
        this.weekDay = false;
        this.repeatDayInMonthValue = this.meetingResponse.onDate[0];
        if (this.repeatValue == 1) {
          this.frequencyValue = 'Occurs every month on day ' + this.repeatDayInMonthValue + a + " " + this.meetingResponse.shortTimeZone;
        }
        else {
          this.frequencyValue = 'Occurs every ' + this.repeatValue + ' months on day ' + this.repeatDayInMonthValue + a + " " + this.meetingResponse.shortTimeZone;
        }
      }
      else {
        this.weekDay = true;
        this.day = false;
        this.repeatWeekInMonthValue = this.meetingResponse.onDate[0];
        this.repeatWeekDayInMonthValue = this.meetingResponse.onDate[1];
        if (this.repeatValue == 1) {
          this.frequencyValue = 'Occurs every month on ' + this.getOptionNameByValue(this.repeatWeekInMonthValue, this.meetingWeekInMonth) + ' ' + this.getOptionNameByValue(this.repeatWeekDayInMonthValue, this.meetingDayInWeek) + a + " " + this.meetingResponse.shortTimeZone;
        }
        else {
          this.frequencyValue = 'Occurs Every ' + this.repeatValue + ' months on ' + this.getOptionNameByValue(this.repeatWeekInMonthValue, this.meetingWeekInMonth) + ' ' + this.getOptionNameByValue(this.repeatWeekDayInMonthValue, this.meetingDayInWeek) + a + " " + this.meetingResponse.shortTimeZone;
        }
      }
    }

    if (this.meetingFrequency.value == 'Y') {
      if (this.meetingResponse.onDate.length == 2) {
        this.monthDay = true;
        this.monthweekDay = false;
        this.repeatMonthYearValue = this.meetingResponse.onDate[0];
        this.repeatDayInYearValue = this.meetingResponse.onDate[1];
        if (this.repeatValue == 1) {
          this.frequencyValue = 'Occurs every year on day ' + this.repeatDayInYearValue + ' of ' + this.getOptionNameByValue(this.repeatMonthYearValue, this.meetingMonths) + a + " " + this.meetingResponse.shortTimeZone;
        }
        else {
          this.frequencyValue = 'Occurs every ' + this.repeatValue + " years on day " + this.repeatDayInYearValue + ' of ' + this.getOptionNameByValue(this.repeatMonthYearValue, this.meetingMonths) + a + " " + this.meetingResponse.shortTimeZone;
        }
      }
      else {
        this.monthweekDay = true;
        this.monthDay = false;
        this.repeatYearlyInMonthValue = this.meetingResponse.onDate[0];
        this.repeatYearlyWeekValue = this.meetingResponse.onDate[1];
        this.repeatYearlyWeekDayValue = this.meetingResponse.onDate[2];
        if (this.repeatValue == 1) {
          this.frequencyValue = 'Occurs every year on the ' + this.getOptionNameByValue(this.repeatYearlyWeekValue, this.meetingWeekInMonth) + " " + this.getOptionNameByValue(this.repeatYearlyWeekDayValue, this.meetingDayInWeek) + " of " + this.getOptionNameByValue(this.repeatYearlyInMonthValue, this.meetingMonths) + a + " " + this.meetingResponse.shortTimeZone;
        }
        else {
          this.frequencyValue = 'Occurs every ' + this.repeatValue + 'years on the ' + this.getOptionNameByValue(this.repeatYearlyWeekValue, this.meetingWeekInMonth) + " " + this.getOptionNameByValue(this.repeatYearlyWeekDayValue, this.meetingDayInWeek) + " of " + this.getOptionNameByValue(this.repeatYearlyInMonthValue, this.meetingMonths) + a + " " + this.meetingResponse.shortTimeZone;
        }
      }
    }

    this.repeatDayInMonthValue
    this.recurChange.setValue("CUR");
    //this.updateMeetingInfo.controls['recurTillDateStr'].setValue(this.datepipe.transform(this.meetingResponse.recurTillDateStr, "EEEE, MMM dd, YYYY"))
    //  this.defaultApprovalField.setValue(this.defaultApproval.controlValue)

  }

  //used to update meetingPurpose
  updatemeetingPurpose(meetingId: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }

    //this.dateFormatChange();
    const meetingPurposeObj = {
      "meetingPurpose": this.meetingPurpose.value,
    }
    const updateMeetingPurpose = Object.assign({}, this.updateMeetingInfo.value, meetingPurposeObj)
    this.meetingService.updateMeeting(meetingId, updateMeetingPurpose).subscribe(async responsedata => {

      this.meetingResponse.meetingPurpose = this.meetingPurpose.value;
      await this.trackMeetingResponse();
      const reqJSON = { "fieldName": "meetingPurpose", "fieldValue": this.meetingPurpose.value, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }


  //used to update location
  updateLocation(meetingId: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }

    this.dateFormatChange();
    const locationObj = {
      "location": this.location.value,
    }
    const updateLocation = Object.assign({}, this.updateMeetingInfo.value, locationObj)
    this.meetingService.updateMeeting(meetingId, updateLocation).subscribe(responsedata => {
      //
      this.meetingResponse.location = this.location.value;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "location", "fieldValue": this.location.value, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);

    })
  }

  //used to update meeting type
  updateMeetingType(meetingId: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    this.dateFormatChange();

    const meetingTypeObj = {
      "meetingType": this.meetingType.value
    }
    const updateMeetingType = Object.assign({}, this.updateMeetingInfo.value, meetingTypeObj)
    this.meetingService.updateMeeting(meetingId, updateMeetingType).subscribe(responsedata => {
      //
      this.meetingResponse.meetingType = this.meetingType.value;
      this.meetingResponse.meetingTypeCode = responsedata.body.meetingTypeCode;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "meetingType", "fieldValue": this.meetingType.value, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }
  //used to update frequency
  updateFrequency(meetingId: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);
    if (!roleFlag) {
      return;
    }
    this.dateFormatChange();
    var json = {
      startDate: this.meetingDate.value,
      visitorTimeZone: this.globals.vTimeZone
    }
    if (this.meetingFrequency.value == 'W') {
      this.meetingDaysCheckbox[this.meetingDate.value.getDay()].checked = true;

    } else if (this.meetingFrequency.value == 'M') {
      this.repeatDayInMonthValue = this.meetingDate.value.getDate();
      this.meetingService.getWeekOfMonth(json).subscribe((data: any) => {
        this.repeatWeekInMonthValue = data.body;
      });
      this.repeatWeekDayInMonthValue = this.meetingDate.value.getDay()
    }
    else if (this.meetingFrequency.value == 'Y') {
      this.repeatMonthYearValue = this.meetingDate.value.getMonth() + 1;
      this.repeatDayInYearValue = this.meetingDate.value.getDate();
      this.repeatYearlyInMonthValue = this.meetingDate.value.getMonth() + 1;
      this.meetingService.getWeekOfMonth(json).subscribe((data: any) => {
        this.repeatYearlyWeekValue = data.body;
      });
      this.repeatYearlyWeekDayValue = this.meetingDate.value.getDay()
    }
    this.repeatValue = 1;
    const frequencyObj: any = {
      "meetingFrequency": this.meetingFrequency.value,
      "frequentVal": this.repeatValue
    }

    const updateFrequency = Object.assign({}, this.updateMeetingInfo.value, frequencyObj)
    this.meetingService.updateMeeting(meetingId, updateFrequency).subscribe(responsedata => {
      this.meetingResponse.meetingFrequency = this.meetingFrequency.value;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "meetingFrequency", "fieldValue": this.meetingFrequency.value, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
      this.updateOnDate(meetingId);
    })

  }

  //used to update till date
  updateTillDate(meetingId: any) {
    return new Promise((resolve, reject) => {
      this.dateFormatChange();
      let formattedMeetingDate;
      if (this.recurTillDateStr.value) {
        // Convert the value to a string
        let stringValue = String(this.recurTillDateStr.value);
        // Now you can safely use .split() on the string
        let dateParts = stringValue.split(' ');
        let month = dateParts[1];  // e.g., 'Dec'
        let day = dateParts[2];    // e.g., '30'
        let year = dateParts[3];   // e.g., '2024'
        formattedMeetingDate = `${month} ${day}, ${year}`;
      }
      var recurObj: any = {
        "recurTillDateStr": formattedMeetingDate + "",
      }
      if (this.repeatValue != null || this.repeatValue != undefined) {
        recurObj = {
          "recurTillDateStr": formattedMeetingDate + "",
          "frequentVal": this.repeatValue
        }
      }
      const recurJson = Object.assign({}, this.updateMeetingInfo.value, recurObj);
      this.meetingService.updateMeeting(meetingId, recurJson).subscribe(responsedata => {
        //
        this.meetingResponse.recurTillDateStr = this.recurTillDateStr.value;
        this.meetingResponse.frequentVal = this.repeatValue;
        this.trackMeetingResponse();
        const reqJSON = { "fieldName": "recurTillDateStr", "fieldValue": this.datepipe.transform(this.recurTillDateStr.value, "MMM dd, YYYY"), "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);
        resolve(responsedata);
      })
    });

  }

  upDateFrequentValue(meetingId: any) {
    this.dateFormatChange();
    const recurObj = {
      "frequentVal": this.repeatValue
    }
    const recurJson = Object.assign({}, this.updateMeetingInfo.value, recurObj);
    this.meetingService.updateMeeting(meetingId, recurJson).subscribe(responsedata => {
      this.meetingResponse.frequentVal = this.repeatValue;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "frequentVal", "fieldValue": this.repeatValue, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }


  updateOnDate(meetingId: any) {
    if (this.meetingFrequency.value == 'D' || this.meetingFrequency.value == "N") {
      return;
    }

    this.dateFormatChange();
    var recurObj: any;
    if (this.meetingFrequency.value == 'W') {
      const onDate = this.meetingDaysCheckbox
        .filter((item: any) => item.checked)
        .map((item: any) => item.value);
      recurObj = {
        "onDate": onDate,
      }
    }

    if (this.meetingFrequency.value == 'M') {
      if (this.day) {
        const onDate = [this.repeatDayInMonthValue];
        recurObj = {
          "onDate": onDate,
        }
      }
      if (this.weekDay) {
        const onDate = [0, -1];
        if (this.repeatWeekInMonthValue != undefined && this.repeatWeekInMonthValue != null) {
          onDate[0] = this.repeatWeekInMonthValue;
        }
        if (this.repeatWeekDayInMonthValue != undefined && this.repeatWeekDayInMonthValue != null) {
          onDate[1] = this.repeatWeekDayInMonthValue;
        }
        recurObj = {
          "onDate": onDate,
        }
      }
    }


    if (this.meetingFrequency.value == 'Y') {
      if (this.monthDay) {

        const onDate = [0, 0]
        if (this.repeatMonthYearValue != null && this.repeatMonthYearValue != undefined) {
          onDate[0] = this.repeatMonthYearValue
        }
        if (this.repeatDayInYearValue != null && this.repeatDayInYearValue != undefined) {
          onDate[1] = this.repeatDayInYearValue
        }
        recurObj = {
          "onDate": onDate,
          "frequentVal": this.repeatValue
        }
      }
      if (this.monthweekDay) {

        const onDate = [0, 0, -1]
        if (this.repeatYearlyInMonthValue != null && this.repeatYearlyInMonthValue != undefined) {
          onDate[0] = this.repeatYearlyInMonthValue
        }
        if (this.repeatYearlyWeekValue != null && this.repeatYearlyWeekValue != undefined) {
          onDate[1] = this.repeatYearlyWeekValue
        }
        if (this.repeatYearlyWeekDayValue != null && this.repeatYearlyWeekDayValue != undefined) {
          onDate[2] = this.repeatYearlyWeekDayValue
        }
        recurObj = {
          "onDate": onDate,
          "frequentVal": this.repeatValue
        }
      }
    }

    const recurJson = Object.assign({}, this.updateMeetingInfo.value, recurObj);
    this.meetingService.updateMeeting(meetingId, recurJson).subscribe(responsedata => {
      this.meetingResponse.onDate = recurObj.onDate;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "onDate", "fieldValue": recurObj.onDate, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }

  onCategorySelect(event: any): void {
    const categoryObj = {
      "minTemplateId": null,
      "categoryId": event.value,
    };
    const updateCategoryInfo = Object.assign({}, this.updateMeetingInfo.value, categoryObj);
    this.meetingService.updateMeeting(this.meetingResponse.meetingId, updateCategoryInfo).subscribe(responsedata => {
      // this.meetingResponse.categoryId = event.value;
      // this.trackMeetingResponse();
      this.meetingResponse.categoryId = event.value;
      this.meetingResponse.minTemplateId = null;
      this.latestMeetingResponse.emit(this.meetingResponse);
    });
    const subCategoryReq = {
      fkCategory: event.value,
      orgCode: localStorage.getItem("orgCode"),
      createdBy: localStorage.getItem("userId")
    };
    this.fetchTemplate(subCategoryReq, this.meetingResponse.meetingId);
  }


  fetchTemplate(reqJSON: any, meetingId: any): void {
    this.spinner.show();
    this.meetingService.fetchMinutesTemplate(reqJSON).subscribe((response: any) => {
      this.spinner.hide();
      var templateList = response.body;
      if (templateList.length == 0) {
        this.notifiy.show({
          type: 'error',
          message: 'No templates available.Please choose another'
        });
        this.subCategories = [];
        return;
      }
      this.subCategories = response.body
    });

  }

  onSubCategorySelect(event: any): void {
    this.spinner.show();
    const templateObj = {
      "minTemplateId": event.value
    };

    this.meetingService.fetchMinutesTemplateById(templateObj).subscribe((response: any) => {

      const dialogRef = this.dialog.open(TemplateDialogComponent, {
        data: { htmlContent: response.body.formatedHTML },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100vw",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      });
    })


    const updateTemplateInfo = Object.assign({}, this.updateMeetingInfo.value, templateObj);
    this.meetingService.updateMeeting(this.meetingResponse.meetingId, updateTemplateInfo).subscribe(responsedata => {
      // this.meetingResponse.categoryId = responsedata.body.categoryId;
      this.meetingResponse.minTemplateId = responsedata.body.minTemplateId;
      this.latestMeetingResponse.emit(this.meetingResponse);
      this.spinner.hide();
    });

  }


  updateTillDates(meetingId: any, meetingDate: any) {
    return new Promise((resolve, reject) => {
      this.dateFormatChange();

      let formattedMeetingDate;
      if (this.recurTillDateStr.value) {
        // Convert the value to a string
        let stringValue = String(this.recurTillDateStr.value);
        // Now you can safely use .split() on the string
        let dateParts = stringValue.split(' ');
        let month = dateParts[1];  // e.g., 'Dec'
        let day = dateParts[2];    // e.g., '30'
        let year = dateParts[3];   // e.g., '2024'
        formattedMeetingDate = `${month} ${day}, ${year}`;
      }
      var recurObj: any = {
        "recurTillDateStr": formattedMeetingDate + "",
      }
      if (meetingDate != null) {
        recurObj = {
          "recurTillDateStr": formattedMeetingDate + "",
          "meetingDateStr": meetingDate
        }
      }
      const recurJson = Object.assign({}, this.updateMeetingInfo.value, recurObj);
      this.meetingService.updateMeeting(meetingId, recurJson).subscribe(responsedata => {
        this.meetingResponse.recurTillDateStr = this.recurTillDateStr.value;
        this.trackMeetingResponse();
        const reqJSON = { "fieldName": "recurTillDateStr", "fieldValue": this.datepipe.transform(this.recurTillDateStr.value, "MMM dd, YYYY"), "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);
        resolve(responsedata);
      })
    });

  }




  //used to udate meeting medium
  updateMeetingMedium(meetingId: any, event: any) {
    this.spinner.show();
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      this.spinner.hide();
      return;
    }
    this.dateFormatChange();
    this.isZoomMeeting = false;
    if (event.target.attributes.desc.value == "Zoom") {
      //check whether user synced with zoom
      var zoomReqJson = {
        "fkSecUserId": localStorage.getItem("userId"),
        "webConfType": "Zoom"
      }
      this.userService.checkUserWebConfExists(zoomReqJson).subscribe((data: any) => {

        if (data.body.isUserAuthorized) {
          this.zoomCheck.setValue('Y');
          this.isZoomMeeting = true;
          const zoomObj = {
            "zoomCreateMeeting": "Y",
          }
          const meetingMediumObj = {
            "meetingMedium": this.meetingMedium.value,
            "zoomCreateMeeting": "Y"
          }
          const updateMeetingMedium = Object.assign({}, this.updateMeetingInfo.value, meetingMediumObj)
          this.meetingService.updateMeeting(meetingId, updateMeetingMedium).subscribe(responsedata => {
            //
            this.meetingResponse.meetingMedium = this.meetingMedium.value;
            this.meetingResponse.zoomCreateMeeting = "Y";
            this.meetingResponse.location = responsedata.body.location;
            this.trackMeetingResponse();
            this.createZoomMeeting.emit(responsedata.body.zoomCreateMeeting)
            this.meetingMediumChanged.emit(responsedata.body);

            const reqJSON = { "fieldName": "meetingMedium", "fieldValue": this.meetingMedium.value, "meetingId": this.meetingResponse.meetingId }
            this.callWebsocketService(reqJSON);
            this.spinner.hide();
          })
        }
        else {
          this.spinner.hide();
          this.sideNav.alertMeetingReason('You are yet to integrate with Zoom. Please integrate using your profile option', 'error');
          this.meetingMedium.setValue(this.meetingResponse.meetingMedium);
        }
      });
      //close
    } else {
      const meetingMediumObj = {
        "meetingMedium": this.meetingMedium.value,
        "zoomCreateMeeting": "N",
      }
      const updateMeetingMedium = Object.assign({}, this.updateMeetingInfo.value, meetingMediumObj)
      this.meetingService.updateMeeting(meetingId, updateMeetingMedium).subscribe(responsedata => {
        //
        this.meetingResponse.meetingMedium = this.meetingMedium.value;
        this.trackMeetingResponse();
        this.meetingMediumChanged.emit(responsedata.body);
        const reqJSON = { "fieldName": "meetingMedium", "fieldValue": this.meetingMedium.value, "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);
        this.spinner.hide();
      })
    }
  }
  updateWeekEndFlag(meetingId: any) {
    this.dateFormatChange();

    const reqObj = {
      "weekEndFlag": this.weekEndFlag.value ? 'Y' : 'N'
    }
    const jsonReq = Object.assign({}, this.updateMeetingInfo.value, reqObj)
    this.meetingService.updateMeeting(meetingId, jsonReq).subscribe(responsedata => {
      //
      //this.updateRecurFields(this.meetingResponse);
      this.meetingResponse.weekEndFlag = this.weekEndFlag.value;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "weekEndFlag", "fieldValue": this.weekEndFlag.value ? 'Y' : 'N', "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }

  updateRecurFields() {
    const recurCheckBox = this.recurChange.value;
    if (recurCheckBox == environment_const.recurChangeToAll && this.meetingResponse.recurDetailsId != null) {
      // this.dialog.open(ConfirmDialogComponent, {    
      //   data: {
      //     dialogTitle : "Confirmation",
      //     dialogContent : environment_msg.msg_confirm_update_recur_changes
      //   },
      // }).afterClosed().subscribe((confirmed: boolean) => {
      //   if (confirmed) {
      this.meetingService.updateRecurringMeetingInfo(this.meetingResponse).then((rsp: any) => {

      });
      //   }
      // });

    }
  }

  disableTillDate() {
    if (this.recurChange.value == environment_const.recurChangeToAll || (this.utilService.nvl(this.meetingResponse.recurVisibleFlag) == "")) {
      return false;
    } else {
      return true;
    }
  }

  disableWeekEnd() {
    if (this.recurChange.value == environment_const.recurChangeToAll || (this.utilService.nvl(this.meetingResponse.recurVisibleFlag) == "")) {
      this.weekEndFlag.enable();
      return false;
      //this.weekEndFlag.enable();
    } else {
      this.weekEndFlag.disable();
      return true;
    }
  }

  zoomCreateMeeting(event: any, meetingId: any) {

    if (event.value == "Y") {

      const zoomObj = {
        "zoomCreateMeeting": "Y",
      }
      this.createZoomMeeting.emit(zoomObj.zoomCreateMeeting)
      var updateZoom = Object.assign({}, this.updateMeetingInfo.value, zoomObj)
      this.meetingService.updateMeeting(meetingId, updateZoom).subscribe(responsedata => {


        const reqJSON = { "fieldName": "zoomCreateMeeting", "fieldValue": "Y", "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);
        //this.trackMeetingResponse();
      })

    } else {
      const zoomObj = {
        "zoomCreateMeeting": "N",
      }
      this.createZoomMeeting.emit(zoomObj.zoomCreateMeeting)
      var updateZoom = Object.assign({}, this.updateMeetingInfo.value, zoomObj)
      this.meetingService.updateMeeting(meetingId, updateZoom).subscribe(responsedata => {
        const reqJSON = { "fieldName": "zoomCreateMeeting", "fieldValue": "N", "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);
        //this.trackMeetingResponse();
      })

    }
  }

  recurRadioChange($event: MatRadioChange) {

    if ($event.value === environment_const.recurChangeToAll) {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialogTitle: "Confirmation",
          dialogContent: environment_msg.msg_confirm_update_recur_changes
        },
      }).afterClosed().subscribe((confirmed: boolean) => {
        if (!confirmed) {
          this.recurChange.setValue(environment_const.recurChangeToCurrent);
        }
      });
    }
  }

  //used to update meeting start time
  updateMeetingTime(meetingId: any, event: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }

    this.dateFormatChange();

    this.check();
    if (event.target.value.length != "" && this.updateMeetingInfo.controls['duration'].value.length != "") {
      this.meetingService.updateMeeting(meetingId, this.updateMeetingInfo.value).subscribe(responsedata => {


        if (responsedata.body != undefined && responsedata.body != null) {
          this.meetingResponse.meetingStatusCode = responsedata.body.meetingStatusCode;
          this.meetingResponse.meetingEndFlag = responsedata.body.meetingEndFlag;
          this.meetingResponse.meetingStartTime = this.updateMeetingInfo.controls['meetingStartTime'].value;
          this.meetingResponse.meetingUTCDate = responsedata.body.meetingUTCDate;
          this.meetingResponse.meetingDateFullFormat = responsedata.body.meetingDateFullFormat;
          this.meetingResponse.meetingDateShortFormat = responsedata.body.meetingDateShortFormat;

          this.trackMeetingResponse();
          if (responsedata.body.meetingStatusCode != undefined && responsedata.body.meetingStatusCode == 'COM') {
            this.meetingStatusEmit.emit(responsedata.body.meetingStatusCode);
          }
          this.minuteContentEmit.emit(responsedata.body)
          const reqJSON = { "fieldName": "meetingResponse", "fieldValue": this.meetingResponse, "meetingId": this.meetingResponse.meetingId }
          this.collabMeetingDateAndTime(reqJSON);

        }

        //this.trackMeetingResponse();

      })
    }
    else {
      event.preventDefault();
    }
  }


  //used to update default approval hours
  updateDefaultApprovalHours(meetingId: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    this.dateFormatChange();
    const approvalHours = {
      "approvalHours": this.defaultApproval.value
    }
    const updateMeetingMedium = Object.assign({}, this.updateMeetingInfo.value, approvalHours)
    this.meetingService.updateMeeting(meetingId, updateMeetingMedium).subscribe(responsedata => {
      this.meetingResponse.approvalHours = this.defaultApproval.value;
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "approvalHours", "fieldValue": Number(this.defaultApproval.value), "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })

    //this.check();

  }
  //update meeting duration
  updateDuration(meetingId: any, event: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    this.dateFormatChange();

    if (event.target.value.length != "" && this.updateMeetingInfo.controls['meetingStartTime'].value.length != "") {
      this.meetingService.updateMeeting(meetingId, this.updateMeetingInfo.value).subscribe(responsedata => {
        //
        if (responsedata.body != undefined && responsedata.body != null) {
          this.meetingResponse.meetingStatusCode = responsedata.body.meetingStatusCode;
          this.meetingResponse.meetingEndFlag = responsedata.body.meetingEndFlag;
          this.meetingResponse.duration = this.updateMeetingInfo.controls['duration'].value;
          this.trackMeetingResponse();
          this.secondContentEmit.emit(event.target.value)
        }
        const reqJSON = { "fieldName": "meetingResponse", "fieldValue": this.meetingResponse, "meetingId": this.meetingResponse.meetingId }
        this.collabMeetingDateAndTime(reqJSON);
        //this.trackMeetingResponse();
      })
    }
    else {
      event.preventDefault();
      this.check();
    }
  }
  dateFormatChange() {
    const meetingDate = this.datepipe.transform(moment(this.meetingDate.value).format('MMM DD, yyyy'));

    this.updateMeetingInfo.controls['meetingDateStr'].setValue(meetingDate)
  }
  //method is used to  update meeting date
  //method is used to  update meeting date
  updateDate(meetingId: any) {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    // window.alert("triggered")

    this.dateFormatChange();
    if (this.updateMeetingInfo.controls['duration'].value.length != "" && this.updateMeetingInfo.controls['meetingStartTime'].value.length != "") {

      if ((new Date(this.updateMeetingInfo.controls['meetingDateStr'].value) < new Date()) && this.instantMeetingStarted == true) {

        const meetingJson = {
          "duration": this.updateMeetingInfo.controls['duration'].value,
          "meetingDateStr": this.updateMeetingInfo.controls['meetingDateStr'].value,
          "meetingStartTime": this.updateMeetingInfo.controls['meetingStartTime'].value,
          "orgCode": this.updateMeetingInfo.controls['orgCode'].value,
          "userId": this.updateMeetingInfo.controls['userId'].value,
          "visitorTimeZone": this.updateMeetingInfo.controls['visitorTimeZone'].value,
          "meetingEndFlag": 'Y'
        }
        this.meetingService.updateMeeting(meetingId, meetingJson).subscribe(responsedata => {
          if (responsedata.body.meetingStatusCode != undefined && responsedata.body.meetingStatusCode == 'COM') {
            this.instantMeetingStarted = false
            this.meetingStatusEmit.emit(responsedata.body.meetingStatusCode);
          }
          if (responsedata.body != undefined && responsedata.body != null) {
            this.meetingResponse.meetingStatusCode = responsedata.body.meetingStatusCode;
            this.meetingResponse.meetingEndFlag = responsedata.body.meetingEndFlag;
            this.meetingResponse.meetingUTCDate = responsedata.body.meetingUTCDate;
            this.meetingResponse.meetingDateFullFormat = responsedata.body.meetingDateFullFormat;
            this.meetingResponse.meetingDateShortFormat = responsedata.body.meetingDateShortFormat;

          }
          this.trackMeetingResponse();
          this.dateContentEmit.emit(this.meetingDate.value);
          const reqJSON = { "fieldName": "meetingResponse", "fieldValue": this.meetingResponse, "meetingId": this.meetingResponse.meetingId }
          this.collabMeetingDateAndTime(reqJSON);
          //this.closeInstantMeeting();

        });



      }
      else {
        this.meetingService.updateMeeting(meetingId, this.updateMeetingInfo.value).subscribe(async responsedata => {
          //this.callWebsocketService(reqJSON);
          if (responsedata.body != undefined && responsedata.body != null) {
            this.meetingResponse.meetingStatusCode = responsedata.body.meetingStatusCode;
            this.meetingResponse.meetingEndFlag = responsedata.body.meetingEndFlag;
            this.meetingResponse.meetingUTCDate = responsedata.body.meetingUTCDate;
            this.meetingResponse.meetingDateFullFormat = responsedata.body.meetingDateFullFormat;
            this.meetingResponse.meetingDateShortFormat = responsedata.body.meetingDateShortFormat;

          }
          await this.trackMeetingResponse();
          this.dateContentEmit.emit(this.meetingDate.value);

          const reqJSON = { "fieldName": "meetingResponse", "fieldValue": this.meetingResponse, "meetingId": this.meetingResponse.meetingId }
          this.collabMeetingDateAndTime(reqJSON);
        })
      }

    }

  }

  //method is used to change the meeting title 
  meetingTitlechange() {
    this.dateFormatChange();
    this.meetingTitleChange = this.updateMeetingInfo.controls['meetingTitle'].value;
    this.valueChange.emit(this.meetingTitleChange)
  }

  //method is used to update create meeting page
  updateMeetingTitle(meetingId: any, event: any) {
    //this.dateFormatChange();
    if (event.target.value.length != "" && this.updateMeetingInfo.controls['duration'].value.length != "" && this.updateMeetingInfo.controls['meetingStartTime'].value.length != "") {
      this.meetingService.updateMeeting(meetingId, this.updateMeetingInfo.value).subscribe(responsedata => {
        const reqJSON = { "fieldName": "meetingTitle", "fieldValue": this.updateMeetingInfo.controls['meetingTitle'].value, "meetingId": this.meetingResponse.meetingId }
        this.callWebsocketService(reqJSON);

      })
    } else {
      this.check();
    }
  }

  //used to disable enter key in meeting title
  disableEnter(event: any) {
    // //
    if (event.keyCode == 13) {
      event.preventDefault();
    }
  }

  //confidential dialog box
  openConfidentialDialog(meetingResponse: any) {
    //alert("meetingResponse::"+JSON.stringify(meetingResponse));
    this.unCheckConfidential = !this.unCheckConfidential;

    const dialogRef = this.dialog.open(ConfidentialDialogComponent, {
      panelClass: ['animate__animated', 'animate__slideInRight'],
      disableClose: true,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh",
      data: { confidentialCheck: this.unCheckConfidential, meetingObj: meetingResponse, meetingDateStr: this.updateMeetingInfo.controls['meetingDateStr'].value }
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.meetingResponse.isConfidential = result.isConfidential
      this.trackMeetingResponse();

      if (result.data == "saved") {
        this.unCheckConfidential = true
      }
      else if (result.decrypt == '') {
        this.unCheckConfidential = true
      }
      else if (result.data == "decrypt") {
        this.meetingResponse.isConfidential = result.isConfidential
        this.trackMeetingResponse();
        this.unCheckConfidential = false
      }
      else if (result.confirmPassword == '') {
        this.unCheckConfidential = false
      }
      else if (localStorage.getItem("decryptData") == '' && localStorage.getItem("dailogRefData") == "false") {
        this.unCheckConfidential = true
      }
      else {
        this.unCheckConfidential = false
      }
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      mediumDialogSubscription.unsubscribe()
    });

  }

  //used to set value in frequency meeting
  frequencyMeeting() {
    this.selectedFrequencyPopup = true;
    this.selectedFrequency = this.meetingFrequency.value;
    // Get the native element of the target
    setTimeout(() => {
      if (this.scrollTarget) {
        this.scrollTarget.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        console.warn('scrollTarget is not available yet');
      }
    });
  }

  callWebsocketService(responsedata: any) {
    const meetingCollabData = <MeetingCollabDetails>{};
    meetingCollabData.collabType = 'MEETING';
    meetingCollabData.fieldName = responsedata.fieldName
    meetingCollabData.fieldValue = responsedata.fieldValue
    meetingCollabData.meetingId = responsedata.meetingId;
    meetingCollabData.userId = localStorage.getItem("userId")


    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      meetingCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }
    else if (this.meetingResponse.projectType != undefined && this.meetingResponse.projectType != null && this.meetingResponse.projectType != "") {
      meetingCollabData.meetTypeVal = this.meetingResponse.projectType;
    } else {
      if (responsedata != undefined && responsedata != null && responsedata != "") {
        meetingCollabData.meetTypeVal = responsedata.meetingType;
      }
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, meetingCollabData).subscribe((data) => {

    });

  }
  collabMeetingDateAndTime(responsedata: any) {
    const meetingCollabData = <MeetingCollabDetails>{};
    meetingCollabData.collabType = 'MEETINGDATEANDTIME';
    meetingCollabData.fieldName = responsedata.fieldName
    meetingCollabData.fieldValue = responsedata.fieldValue
    meetingCollabData.meetingId = responsedata.meetingId;
    meetingCollabData.userId = localStorage.getItem("userId")

    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      meetingCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, meetingCollabData).subscribe((data) => {

    });

  }

  //used to set focus on error field
  check() {
    const focusFields = this.focusFields.toArray();
    for (const field of focusFields) {
      if (field.invalid) {
        field.focus();
        return false;
      }
    }
    return true;
  }

  accepted = false


  openPreviousMeetingHistoryDailog() {

    this.accepted = !this.accepted;
    // this.openPinDialog.emit(true)
    // if(this.deviceLg){
    // this.dialog.open(PreviousMeetingsComponent,{
    //   data : {
    //     showPinIcon : true
    //   },
    //   panelClass: ['animate__animated','animate__slideInRight','rogowclass'],
    //   disableClose: false,
    //   position : {
    //     left : "50%"
    //   },
    //   id : 'link-meeting-wrapper',
    //   maxWidth: "100%",
    //   maxHeight: "100vh",
    //   width : "50%",
    //   height : "100vh"
    // })
    // }
    // if(this.deviceMd){
    //   this.dialog.open(PreviousMeetingHistoryDialogComponent, this.md)
    // }
    // if(this.deviceSm){
    //   this.dialog.open(PreviousMeetingHistoryDialogComponent, this.sm)
    // }
    // if(this.deviceXs){
    //   this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xs)
    // }
    // if(this.deviceXl){
    //   this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xl)
    // }
    // else {
    //   this.dialog.open(PreviousMeetingHistoryDialogComponent, this.lg)
    // }
  }

  ngOnInit(): void {
    this.options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }
    //

    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)

    this.dialog.afterAllClosed.subscribe(event => {
      this.accepted = false;
    });

    //product title drop down
    this.filteredOptions = this.productTitle.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.name)),
      map(name => (name ? this._filter(name) : this.productOptions.slice())),
    );
    // Example: inside your component
    this.updateFormStates();



  }

  updateFormStates() {
    if (this.disableTillDate()) {
      this.recurTillDateStr.disable({ emitEvent: false });
    } else {
      this.recurTillDateStr.enable({ emitEvent: false });
    }

    if (this.disableWeekEnd()) {
      this.weekEndFlag.disable({ emitEvent: false });
    } else {
      this.weekEndFlag.enable({ emitEvent: false });
    }
  }

  trackMeetingResponse() {

    this.latestMeetingResponse.emit(this.meetingResponse);
  }

  trackResp(e: any) {

    this.latestMeetingResponse.emit(this.meetingResponse);
  }
  displayFn(option: any): string {
    return option?.description || '';
  }

  private _filter(name: string): ProductName[] {
    const filterValue = (typeof name === 'string') ? name.toLowerCase() : '';
    return this.projectList.filter((option: { description: any; }) => option.description.toLowerCase().includes(filterValue));
  }

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  openDialog() {
    // window.alert("hello")
  }

  isOpenMeetingInfo() {
    $("#OpenMeetingInfo").hide()
    const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    meetingTitleChanger.contentEditable = 'false'
    const editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = false;
    const dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = false
    meetingTitleChanger.style.borderBottom = '0px';
  }

  closeInstantMeeting() {
    this.booleanEmit.emit(true)
    this.sideNav.openInstantMeeting(false);
    this.meetingResponse.addType = 'A';
    this.meetingResponse.elementType = 'ENDMEETING';
    const sentUserName = localStorage.getItem("userName");
    if (sentUserName != null && sentUserName != undefined) {
      this.meetingResponse.sentByUserName = sentUserName;
    }

  }
  updateMeetingProject(meetingId: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MEETINGS, this.utilService.permissionType.MODIFY);
    if (!roleFlag) {
      return;
    }
    this.dateFormatChange();
    const meetingTypeObj = {
      "projectType": this.productTitle.value
    }
    const updateMeetingType = Object.assign({}, this.updateMeetingInfo.value, meetingTypeObj)
    this.meetingService.updateMeeting(meetingId, updateMeetingType).subscribe(responsedata => {
      this.trackMeetingResponse();
      const reqJSON = { "fieldName": "projectType", "fieldValue": this.productTitle.value, "meetingId": this.meetingResponse.meetingId }
      this.callWebsocketService(reqJSON);
    })
  }

  getOptionNameByValue(value: number, data: any): string {
    const selectedOption = data.find((option: any) => option.value === value);
    return selectedOption ? selectedOption.name : '';
  }

  showDayValue(meetingId: any) {
    this.weekDay = false;
    this.day = true;
    // if(this.repeatDayInMonthValue!=undefined){
    this.updateOnDate(meetingId);
    //}
  }

  showMonthDayValue(meetingId: any) {
    this.monthweekDay = false
    this.monthDay = true
    // if(this.repeatMonthYearValue!=undefined || this.repeatDayInYearValue){
    this.updateOnDate(meetingId);
    //}
  }

  showMonthWeekDayValue(meetingId: any) {
    this.monthweekDay = true
    this.monthDay = false
    //if(this.repeatYearlyInMonthValue!=undefined || this.repeatYearlyWeekValue!=undefined || (this.repeatYearlyWeekDayValue != undefined)){
    this.updateOnDate(meetingId);
    //}
  }

  showWeekDayValue(meetingId: any) {
    this.day = false;
    this.weekDay = true;
    // if(this.repeatWeekInMonthValue != undefined || this.repeatWeekDayInMonthValue != undefined ){
    this.updateOnDate(meetingId);
    // }
  }

  getFrequencyPosition(el:any) {    
    const rect = el._elementRef.nativeElement.getBoundingClientRect();        
    const right = window.innerWidth - (rect.left + window.scrollX)
    return {
      top: rect.top + window.scrollY +'px',
      left: (rect.left +50) + 'px'
    };
  }

  isSelectedFrequency(){
    return this.selectedFrequency == 'D' || this.selectedFrequency == 'W' || this.selectedFrequency == 'M' || this.selectedFrequency == 'Y';
  }


}
